module.exports = __webpack_public_path__ + "img/admin1.6a6fb005.jpg";